/* eslint-disable */

import { TenantConfigurationNetherlands } from './shared/TenantConfigurationConstants';

const defaultSettings = {
  zIndex: 999,
  helpCenter: {
    suppress: false,
    messageButton: {
      '*': 'Create a ticket',
      nl: 'Maak een supportticket',
      fr: 'Créer un ticket support',
    },
  },
  contactForm: {
    tags: ['adminpulse'],
    subject: true,
  },
  chat: {
    suppress: true,
  },
  answerBot: {
    suppress: true,
  },
  talk: {
    suppress: true,
  },
};

if (typeof window.zE === 'function') {
  window.zE('webWidget', 'updateSettings', { webWidget: defaultSettings });
  window.zE('webWidget', 'hide');
  window.zE('webWidget:on', 'close', function() {
    //Hide help button on close
    window.zE('webWidget', 'hide');
  });
}

const setUserInfo = (tenantId, userName, userEmail, tenantConfiguration) => {
  if (!window.zE) return;

  var tags = ['adminpulse', `${tenantId}`];
  if (parseInt(tenantConfiguration) === TenantConfigurationNetherlands) {
    tags.push('ap-nl');
  }

  defaultSettings.contactForm.tags = tags;

  window.zE('webWidget', 'updateSettings', { webWidget: defaultSettings });
  window.zE('webWidget', 'prefill', {
    name: { value: userName, readOnly: true },
    email: { value: userEmail, readOnly: true },
  });
};

const setLocale = locale => {
  if (!window.zE) return;
  if (locale === 'en-be') {
    locale = 'en-US'; // the zendesk articles were made in culture en-US so this is the locale we need to pass
  }
  window.zE('webWidget', 'setLocale', locale);
};

const createTicket = () => {
  if (!window.zE) return;
  const settings = { ...defaultSettings };
  settings.helpCenter.suppress = true;

  window.zE('webWidget', 'updateSettings', { webWidget: settings });

  window.zE('webWidget', 'show');
  window.zE('webWidget', 'open');
};

export default { setUserInfo, createTicket, setLocale };
